<template>
  <div class="custom-bg bg-image-3">
      <div class="left">
      	<span class="left-span">Hi 你好！</span>
      	<span class="left-span1">欢迎进入公会管理系统</span>
      </div>
	  <div class="box">
	  	<div class="nav" v-if="isWjmm == false">
	  		<button :class="index===navListIndex?'nav-item':'nav-item1'" v-for="(item,index) in navList" :key="index" @click="handlenav(index)">{{item.name}}</button>
	  	</div>
		<div class="form">
			<div class="input">
				<input type="text" v-model="form.phone" maxlength="11" placeholder="请输入手机号码"/>
			</div>
			<div class="input" v-if="navListIndex == 0 && isWjmm == false">
				<input type="text" v-model="form.password" placeholder="请输入密码"/>
			</div>
			<div class="input" v-if="navListIndex == 0 && isWjmm == true">
				<input type="text" v-model="form.newPassword" placeholder="请输入密码"/>
			</div>
			<div class="input" v-if="navListIndex == 1 || isWjmm">
				<input type="text" v-model="form.code" placeholder="请输入验证码"/>
			</div>
			<button class="xzbtn" v-if="navListIndex == 0 && isWjmm == false" @click="handlewangjimima">忘记密码</button>
			<button class="xzbtn" v-if="navListIndex == 1 && countdown == false || isWjmm && countdown == false" @click="getCode">获取验证码</button>
			<button class="xzbtn" v-if="navListIndex == 1 && countdown || isWjmm && countdown">{{timeText}}秒</button>
			<button class="btn" v-if="isWjmm == false" @click="login">登录</button>
			<button class="btn" v-if="isWjmm" @click="update_password">确定</button>
			<button class="xzbtn1" v-if="isWjmm" @click="handlefanhui">返回</button>
			<div class="xieyi" v-if="isWjmm == false">
				<span class="xieyi-span" @click="handlexieyi(0)">《Home用户协议》</span>
				<span class="xieyi-span1">和</span>
				<span class="xieyi-span" @click="handlexieyi(1)">《Home隐私协议》</span>
			</div>
		</div>
	  </div>
  </div>
</template>

<script>
  import { login,send_code,update_password } from '@/api/login';
  import Cookies from 'js-cookie';
  export default {
    data() {
      return {
		navList:[{
			name:'密码登录'
		},{
			name:'验证码登录'
		}],
		navListIndex:0,
		countdown: false,
		timeText:60,
		countdownStartTime: 60,
		timer:null,
		isWjmm:false,
		form:{
			entryType:0,
			password:'',
			code:'',
			phone:'',
			newPassword:'',
			action:3
		},
		newWindow:null
      };
    },
	mounted(){
		
	},
    methods: {
	  //登录
	  login(){
		this.$store.commit('changeToken', '')
		login(this.form).then(response => {
		  sessionStorage.setItem('user', 1);
		  this.$message.success('登录成功');
		  this.$store.commit('changeToken', response.data.token); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeUser', response.data.guildInfo); // 调用 setCount mutation 并传递参数
		  this.$router.replace({ path: '/index' });
		});
	  },
	  //选择密码或者验证码登录
	  handlenav(index){
		this.navListIndex = index
		this.form.entryType = index
		// 清除之前的定时器
		if (this.timer) {
		  clearTimeout(this.timer);
		  this.timer = null;
		}
		// 重置倒计时状态
		this.countdown = false;
		this.timeText = this.countdownStartTime;
	  },
	  //获取验证码
	  getCode(){
		send_code(this.form).then(response => {
		  this.$message.success(response.msg);
		  this.countDown();
		  this.countdown = true;
		});
	  },
	  //倒计时
	  countDown() {
		let nowTime = this.timeText - 1;
		console.log(nowTime,'nowTime')
		if (nowTime >= 0) {
			this.timeText = nowTime;
			this.timer = setTimeout(this.countDown, 1000);
		} else {
			this.countdown = false;
			this.timeText = this.countdownStartTime;
			if (this.timer) {
			  clearTimeout(this.timer);
			  this.timer = null;
			}
		}
	  },
	  //忘记密码
	  handlewangjimima(){
		this.form.action = 2
		this.isWjmm = true
	  },
	  //返回
	  handlefanhui(){
		this.form.action = 3
		this.isWjmm = false
		this.countdown = false;
		this.timeText = this.countdownStartTime;
		if (this.timer) {
		  clearTimeout(this.timer);
		  this.timer = null;
		}
	  },
	  //确定修改密码
	  update_password(){
		update_password(this.form).then(response => {
		  sessionStorage.setItem('user', 1);
		  this.$message.success('修改成功');
		  this.$store.commit('changeToken', response.data.token); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeUser', response.data.guildInfo);
		  this.$router.replace({ path: '/index' });
		});
	  },
	  //跳转协议
	  handlexieyi(data){
		  sessionStorage.setItem('user', 1);
		  // 打开新窗口并加载指定路由
		  this.newWindow = window.open('', '_blank');
		  		
		  if (this.newWindow) {
			// 将路由的完整 URL 写入新窗口
			const params = { id: 123 };
			const query = { type: data };
		  	const route = this.$router.resolve({ name: 'xieyi',params,query });
		  	this.newWindow.location.href = route.href;
		  } else {
		  	alert('弹出窗口被阻止，请允许弹出窗口后重试。');
		  }
	  }
    }
  }

</script>

<style lang="scss" scoped>
    .custom-bg {
      min-height: 100vh;
	  display: flex;
	  flex-direction: row;
	  align-items: center;
	  justify-content: space-between;
	  padding: 0px 8%;
    }
	.bg-image-3 {
	  background-size: cover;
	  background-position: center;
	}
	.left{
		display: flex;
		flex-direction: column;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 42px;
		color: #FFFFFF;
		text-shadow: 0px 4px 8px rgba(0,0,0,0.3);
		line-height: 56px;
	}
	.left-span1{
		padding-top: 26px;
	}
	.box{
		width: 444px;
		height: 475px;
		background: #161618;
		border-radius: 10px 10px 10px 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.nav{
		padding: 0px 80px 0px 80px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.nav-item{
		border: none;
		outline: none;
		padding: 0;
		margin: 0;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 22px;
		color: #ffffff;
		line-height: 30px;
		padding-bottom: 5px;
		border-bottom: 3px solid #ffffff;
		background: none;
	}
	.nav-item1{
		border: none;
		outline: none;
		padding: 0;
		margin: 0;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 22px;
		color: #878787;
		line-height: 30px;
		background: none;
		padding-bottom: 5px;
		border-bottom: 3px solid #161618;
	}
	.form{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding-top: 30px;
	}
	.input{
		width: 371px;
		height: 52px;
		background: #26262B;
		border-radius: 4px 4px 4px 4px;
		margin-bottom: 20px;
	}
	.input input{
		width: 100%;
		outline: none;
		border: none;
		height: 52px;
		width: 100%;
		background: none;
		padding: 0px 24px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		line-height: 52px;
	}
	.xzbtn{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #B06D10;
		line-height: 19px;
		outline: none;
		border: none;
		background: none;
	}
	.xzbtn1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #B06D10;
		line-height: 19px;
		outline: none;
		border: none;
		background: none;
		margin-top: 20px;
	}
	.btn{
		margin-top: 30px;
		width: 371px;
		height: 52px;
		background: #ffffff;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 16px;
		color: #161618;
		line-height: 52px;
		outline: none;
		padding: 0;
		border: 0;
	}
	.miaoshu{
		padding-top: 20px;
		text-align: center;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #9A9A9A;
		line-height: 19px;
	}
	.xieyi{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #B06D10;
		line-height: 19px;
		text-align: center;
		padding-top: 16px;
	}
	.xieyi-span1{
		color: #9a9a9a;
		padding: 0px 8px;
	}
</style>


// WEBPACK FOOTER //
// Ghdenglu.vue?256f181b